// extracted by mini-css-extract-plugin
module.exports = {"textSubtle":"SMATable-module__textSubtle--2B95z","ellipsis":"SMATable-module__ellipsis--3Xg-Y"};